import { createSelector } from 'reselect';
import getRiskTypes from './getRiskTypes';

// Formats data to match alert endpoint riskType slugs
const getRiskOptions = createSelector(
  getRiskTypes,
  (riskTypes = {}) => (
    [...Object.keys(riskTypes)
      .filter(k => riskTypes[k].enabled)
      .map(k => ({
      label: riskTypes[k].title,
      value: riskTypes[k].slug,
    }))]
  ),
);

export default getRiskOptions;
